import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import AcknowledgeIcon from "../../../images/teepee-icon.svg";
import appContext from "../../../context/appContext";
import { useContext } from "react";

function TrialPeriodAcknowledgmentPopupOutsideClass({
  navigatedFromOutsideClassroom,
  subjectName,
  openTrialAcknowledgePopup,
  handleCloseTrialAcknowledgePopup,
  setOpen,
  handleUpgrade,
}) {
  const state = useContext(appContext);

  const handleClickLetsGo = () => {
    handleCloseTrialAcknowledgePopup();
  };

  const handleUpgradeNow = () => {
    handleUpgrade();
    setOpen(true);
  };

  const handleTotalNumberOfQuizzes = () => {
    // console.log("NAVIGATED FROM OUTSIDE in Contition: ", navigatedFromOutsideClassroom);

    // return "14 days";
    // // state.selectedSubjectObject.current?.days_left
    if (localStorage.getItem("email_address") === process.env.REACT_APP_REQUESTED_USER && state.selectedSubjectIdForClass === 10) {
      return "35 days";
    } else {
      var daysLeft = localStorage.getItem("daysLeft");
      return `${daysLeft} days`;
    }
  };

  return (
    <div>
      <Dialog
        PaperProps={{
          sx: {
            width: "60%", // Default width
            height: "auto",
            maxWidth: "70%", // Keeps maximum width constraint
            // maxHeight: "calc(100vh - 50px)", // Prevents vertical overflow
            borderRadius: "12px",
            padding: "16px",
            overflowY: "auto",
            "@media (max-width: 768px)": {
              width: "90%", // Adjust for smaller screens
              padding: "8px", // Reduce padding for compact display
            },
          },
        }}
        open={openTrialAcknowledgePopup}
        onClose={() => handleClickLetsGo()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div>
          <center>
            <DialogContent
              className="sm:ml-[4px] sm:mr-[4px] md:ml-[11%] md:mr-[11%] flex justify-center overflow-y-auto item-center"
              style={{
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                // maxHeight: "calc(100vh - 100px)",
              }}
            >
              <div style={{ maxHeight: "100%", overflowY: "auto" }}>
                <div className="pt-[1.6vh]">
                  <img src={AcknowledgeIcon} className="w-[50px] md:w-[70px]" alt="Acknowledge Icon" />
                </div>
                <div className="mt-[5%] text-xl md:text-2xl font-bold text-[#1D192B] text-center" style={{ fontSize: "clamp(1rem, 1.5vw, 1.25rem)" }}>
                  🎉 Your {handleTotalNumberOfQuizzes()} Free Trial is Active!
                </div>
                <div
                  className="mt-[2%] text-sm md:text-base font-medium text-[#49454F] text-center"
                  style={{
                    lineHeight: "1.5rem",
                    letterSpacing: "0.009rem",
                    fontSize: "clamp(0.8rem, 1.2vw, 1rem)",
                  }}
                >
                  {`You’re on a ${handleTotalNumberOfQuizzes()} free trial for `}
                  <strong>{navigatedFromOutsideClassroom ? subjectName : state.selectedSubjectForClass} —</strong>
                  <strong>
                    <i>no credit card required. </i>
                  </strong>
                  {` You can upgrade after the trial ends, or anytime before.`}
                </div>
                <div className="mt-[5%] flex justify-center">
                  <button
                    className="teepee-button !text-sm !font-semibold h-[40px] !text-[#ffffff] w-[80%] md:w-[60%]"
                    style={{ maxWidth: "300px" }}
                    onClick={handleClickLetsGo}
                  >
                    Continue
                  </button>
                </div>
                <div className="mt-[3%] flex justify-center">
                  <button
                    className="text-[#6750A4] text-sm md:text-base"
                    style={{ fontSize: "clamp(0.9rem, 1.2vw, 1rem)" }}
                    onClick={() => handleUpgradeNow()}
                  >
                    ⚡ Upgrade Now
                  </button>
                </div>
              </div>
            </DialogContent>
          </center>
        </div>
      </Dialog>
    </div>
  );
}

export default TrialPeriodAcknowledgmentPopupOutsideClass;
